import { usePage } from '@inertiajs/react';

// Faithful port of the legacy `useGlobalLocation`/`LocationContext` active-state
// logic, backed by Inertia's `usePage().url` instead of React Router's
// `useLocation()`. `isExactMatch` from the legacy context was never consumed
// by any component, so it is intentionally not ported.
export const useActivePath = () => {
  const { url } = usePage();
  const pathname = url.split('?')[0];

  const isActive = (path: string) => {
    if (path === '/') return pathname === '/';
    return pathname.startsWith(path);
  };

  return { pathname, isActive };
};
